// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"c98efc69","498":"586cb82a","703":"63e3cd4a"}[chunkId] + ".chunk.js";
};